import { batch, useSignal } from '@preact/signals-react'
import { acrissTable, categoriesTable, mappingType, selectedMappingId } from 'Pages/User/CustomMapping/@signals'
import { getSubmit, postSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { useCallback } from 'react'
import { MAPPING_TYPE } from 'Pages/User/CustomMapping/@constants'
import { useToast } from '@hooks'
import { formData } from '@signals'

export default function useMappingForm(method) {
	const isAcrissForm = mappingType.value === MAPPING_TYPE.ACRISS
	const backendUrl = isAcrissForm ? BACKEND_APIS.CUSTOM_ACRISS : BACKEND_APIS.CUSTOM_CATEGORY

	const isFormSubmitting = useSignal(false)
	const isLoadingForm = useSignal(false)
	const { showToast } = useToast()
	const getMapping = useCallback(() => {
		if (selectedMappingId.value) {
			isLoadingForm.value = true
			getSubmit(`${backendUrl}/list`, { id: selectedMappingId.value }).then(res => batch(() => {
				formData.value = res
				isLoadingForm.value = false
			}))
		}
	}, [selectedMappingId.value])

	const submitPayload = useCallback(() => {
		isFormSubmitting.value = true
		postSubmit(`${backendUrl}/${method}`, formData.value).then(res => {
			isAcrissForm
				? acrissTable.value = acrissTable.value.filter(({ idCustom }) => idCustom !== selectedMappingId.value)
				: categoriesTable.value = categoriesTable.value.filter(({ idCustom }) => idCustom !== selectedMappingId.value)
			isAcrissForm ? acrissTable.value = [...res?.length ? res : [res], ...acrissTable.value] : categoriesTable.value = [...res?.length ? res : [res], ...categoriesTable.value]
			isFormSubmitting.value = false
			selectedMappingId.value = null
			formData.value = {}
		}).catch(() => {
			isFormSubmitting.value = false
			selectedMappingId.value = null
			showToast.error()
			formData.value = {}
		})
	}, [])

	return {
		submitPayload,
		getMapping,
		isFormSubmitting: isFormSubmitting.value,
		isLoadingForm: isLoadingForm.value,
	}
}